
































import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { IEditableFormatQuestionnaire } from "../../../../../../domain/editableFormat";

@Component
export default class FormatQuestionnairePropertyEditor extends Mixins(ModelEditableMixin) {
    // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IEditableFormatQuestionnaire) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IEditableFormatQuestionnaire) => T, defaultValue: T) => T;

  get resourceType(): string {
    return this.readPropertyOrDefault(s => s.resourceType, "");
  }

  set resourceType(value: string) {
    this.writePropertyWhenValid(s => s.resourceType = value);
  }

  get version(): string {
    return this.readPropertyOrDefault(s => s.version, "");
  }

  set version(value: string) {
    this.writePropertyWhenValid(s => s.version = value);
  }

  get status(): string {
    return this.readPropertyOrDefault(s => s.status, "");
  }

  set status(value: string) {
    this.writePropertyWhenValid(s => s.status = value);
  }

  get publisher(): string {
    return this.readPropertyOrDefault(s => s.publisher, "");
  }

  set publisher(value: string) {
    this.writePropertyWhenValid(s => s.publisher = value);
  }

  get copyright(): string {
    return this.readPropertyOrDefault(s => s.copyright, "");
  }

  set copyright(value: string) {
    this.writePropertyWhenValid(s => s.copyright = value);
  }

  get experimental(): boolean {
    return this.readPropertyOrDefault(s => s.experimental, false);
  }

  set experimental(value: boolean) {
    this.writePropertyWhenValid(s => s.experimental = value);
  }

  get subjectTypesAsString(): string {
    return this.subjectTypes.join(",");
  }

  set subjectTypesAsString(value: string) {
    this.subjectTypes = value.split(",");
  }

  get subjectTypes(): string[] {
    return this.readPropertyOrDefault(s => s.subjectTypes, []);
  }

  set subjectTypes(value: string[]) {
    this.writePropertyWhenValid(s => s.subjectTypes = value);
  }
}
